import { Pipe, PipeTransform } from '@angular/core';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { nil } from '../helpers/nil.helper';

@Pipe({
  name: 'v2Tel'
})
export class V2TelPipe implements PipeTransform {
  transform(value: string | number | nil): string {
    if (!value) return '';

    const raw = value.toString();
    // E.164 values (leading `+`) carry their own country code; legacy bare
    // values are assumed US, matching how they were historically stored.
    const parsed = raw.startsWith('+')
      ? parsePhoneNumberFromString(raw)
      : parsePhoneNumberFromString(raw, 'US');

    if (!parsed) return raw;

    // Local numbers read best in national format; show international format
    // (with the country code) for everything else.
    return parsed.country === 'US'
      ? parsed.formatNational()
      : parsed.formatInternational();
  }
}
